import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import PriceDisplay from './PriceDisplay';
import GUIInstrumentActions from "../../GUIInstrumentActions";
import {TickProvider} from "../../../contexts/TickContext";
import "../css/GUIInstrumentRow.css";
import {getPortfolioHoldingQuantity,handleTradingsymbolClick} from '../../../services/apiService';  // Import the function to fetch querterlyHolding quantity
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import PriceDifferenceDisplay from "./PriceDifferenceDisplay";
import LastTradedPriceDisplay from "./LastTradedPriceDisplay";
import {handlePriceDifferenceChange} from "./InstrumentUtils";
import MoreDetailsLayout from "./MoreDetails/MoreDetailsLayout";
import {DataContext} from "../../../contexts/DataContext";  // You need to implement this function
import {AnnouncementProvider, useAnnouncementContext} from "../../../contexts/ExchangeAnnContext";
import AnnouncementList from "@dashboard/grid-components/announcements/AnnouncementList";
import {handleDeleteFromOldGrid, handleShowAnnouncements} from "@marketwatch/gridcomponents/util/GridOperations";
import {handleShowDetails} from "@marketwatch/gridcomponents/guiinstrumentrow/MoreDetails/MoreDetailsOperations";
import ActionButtons from "@marketwatch/gridcomponents/components/ActionButtons";
import { useInstrumentRowContext} from '../../../contexts/InstrumentRowContext'; // adjust path as needed

const GUIInstrumentRow = ({onShowChart}) => {
    const {
        GUIInstrument,
        setLayouts,
        layoutIndex,
        uniqueId
    } = useInstrumentRowContext();
    const [holdingQuantity, setHoldingQuantity] = useState(null);  // State to store querterlyHolding quantity
    const [isFetching, setIsFetching] = useState(true);  // State to track fetching status
    const [priceColor, setPriceColor] = useState('black');  // Set default color for tradingsymbol
    const [lastPriceColor, setLastPriceColor] = useState('black');  // Set default color for last-traded-price
    const rowWrapperRef = useRef(null);
    const {screenerURLs} = useContext(DataContext);
    const [showAnnouncementDetails, setShowAnnouncementDetails] = useState(GUIInstrument.forceShowAnnouncements || false);
    const {announcements, newAnnouncements, clearAnnouncements,isUnmounting,setIsUnmounting} = useAnnouncementContext();
    const hasNewAnnouncements = newAnnouncements && newAnnouncements.length > 0;

    // Create unique keys for each announcement using BOTH BroadcastTime and message
    const announcementKey = (a) => `${a.broadcastTime}|${a.message}`;

    useEffect(() => {
        setShowAnnouncementDetails(!!GUIInstrument.forceShowAnnouncements);
    }, [GUIInstrument.forceShowAnnouncements]);

    // Fetch querterlyHolding quantity when the component is mounted
    useEffect(() => {
        const fetchHoldingQuantity = async () => {
            const quantity = await getPortfolioHoldingQuantity(GUIInstrument.tradingsymbol);
            setHoldingQuantity(quantity);
            setIsFetching(false);  // Mark as done fetching
        };

        fetchHoldingQuantity();
    }, [GUIInstrument.tradingsymbol]);

// Use the utility function for price difference change
    /*const handlePriceDifference = useCallback(handlePriceDifferenceChange(onPriceDifferenceUpdate, GUIInstrument), [
        GUIInstrument.instrumentToken,
        onPriceDifferenceUpdate
    ]);*/

    return (
        <div className="gui-instrument-row-wrapper" ref={rowWrapperRef}>

            <TickProvider key={uniqueId} instrumentToken={GUIInstrument.instrumentToken}>
                <div className="gui-instrument-row">
                    <div className="instrument-info-wrapper">
                        <div className="mw-instrument-info">
                            <div className="mw-symbol_n_exchange">
                            <span className="tradingsymbol" style={{color: priceColor}}
                                  onClick={() => handleTradingsymbolClick(GUIInstrument.tradingsymbol,screenerURLs)}>
                                {GUIInstrument.tradingsymbol}
                            </span>
                                <span className="exchange-name">{GUIInstrument.exchange}</span>
                            </div>
                            <PriceDifferenceDisplay
                                instrumentToken={GUIInstrument.instrumentToken}
                                setPriceColor={setPriceColor}
                                setLastPriceColor={setLastPriceColor}  // Pass color change for last-traded-price
                                /*onPriceDifferenceChange={handlePriceDifference}*/
                                contextName={'TickContext'}
                            />
                            <div style={{width: '5px'}}>
                                <span></span>
                            </div>
                            <span className="mw-querterlyHolding-quantity">
                                {!isFetching && holdingQuantity !== null && (
                                    <>
                                        <ShoppingBagIcon style={{fontSize: '11px', verticalAlign: 'middle'}}/>
                                        &nbsp;&nbsp;{holdingQuantity}
                                    </>
                                )}
                            </span>
                            <div className="mw-announcement-button-div">
                                <button
                                    className={`mw-announcement-button ${hasNewAnnouncements ? '' : 'is-hidden'}`}
                                >
                                    A
                                </button>
                            </div>
                            <LastTradedPriceDisplay
                                instrumentToken={GUIInstrument.instrumentToken}
                                priceColor={lastPriceColor}  // Pass the color for last-traded-price
                                contextName={'TickContext'}
                            />
                        </div>
                             <ActionButtons onShowChart={onShowChart}/>
                    </div>
                        {GUIInstrument.isDetailsVisible && (
                            <MoreDetailsLayout
                                setLayouts={setLayouts}
                                instrumentToken={GUIInstrument.instrumentToken}
                                layoutIndex={layoutIndex}
                                rowWrapperRef={rowWrapperRef}
                                contextName={'TickContext'}
                            />
                        )}
                    {showAnnouncementDetails && (
                            <AnnouncementList calledBy={"MW"}/>
                        )}
                </div>
            </TickProvider>
        </div>
    );
};

export default GUIInstrumentRow;
